import { useQuery } from "@tanstack/react-query";
import { useSelectedSimulation } from "./useSimulationStore";
import { sapienAxios } from "@/inertia-utils/hooks";
import { TimeHorizonShape } from "@/models";
import { useMemo } from "react";

export function useTimeHorizons() {
    const {selectedSimulation} = useSelectedSimulation();

    const {data: timeHorizons, isLoading} = useQuery({
        queryKey: ['time-horizons', selectedSimulation?.id],
        queryFn: async () => {
            const {data} = await sapienAxios.get<TimeHorizonShape[]>('creator.design.time-horizons.index',{
                simulationId: selectedSimulation?.id,
            });
            if (!Array.isArray(data)) {
                return []
            }
            // Sort time horizons by time_index
            return data.sort((a, b) => a.time_index - b.time_index);
        },
        enabled: !!selectedSimulation?.id,
        initialData: [],
    });

    // Stabilize the array reference to prevent unnecessary re-renders
    const stableTimeHorizons = useMemo(() => timeHorizons || [], [timeHorizons]);

    return {
        timeHorizons: stableTimeHorizons,
        isLoading,
    };
}
